<template>
  <div class="page-home-v2">
    <section class="part1">
      <div class="a-main">
        <div class="a-flex a-flex-col-center">
          <div class="a-words-box clr-fff">
            <p class="ft-title-a a-mgb-35">
              SMARTZ AI for Your Smart Home Management
            </p>
            <p class="ft-text-a a-mgb-75">
              SMARTZ AI is an Agentic AI which transforms home and rental
              property management by autonomously controlling smart home systems
              and optimizing operational tasks. These intelligent agents
              proactively handle environment control, tenant communications,
              maintenance scheduling, and market analysis, enabling property
              owners to maximize efficiency with minimal personal intervention.
            </p>
            <button class="a-btn" style="width: 45%; min-width: 300px">
              Get Started
              <img
                style="margin-left: 12px; width: 22px"
                src="/static/images/home_v2/icon-1.png"
                alt=""
              />
            </button>
          </div>
          <div class="a-media-box">
            <!-- <img class="a-width-100" src="/static/images/home_v2/banner_1.png" alt=""> -->
            <div
              class="a-video-box"
              style="pointer-events: none; width: 116%; margin-left: -7%"
            >
              <video
                src="/static/video/home_v2/1-1k.webm?v=1.0.1"
                webkit-playsinline="true"
                playsInline="true"
                x5-video-player-type="h5"
                x5-video-player-fullscreen="true"
                x-webkit-airplay="true"
                muted
                loop
                autoPlay
              ></video>
            </div>
            <!-- <div class="a-video-box-phone">
              <video
                src="/static/video/home_v2/1-1-phone.mp4"
                webkit-playsinline="true"
                playsinline="true"
                x5-video-player-type="h5"
                x5-video-player-fullscreen="true"
                x-webkit-airplay="true"
                muted
                loop
                autoplay
              ></video>
            </div> -->
          </div>
        </div>
      </div>
    </section>
    <section class="part1-phone">
      <div class="a-video-box-phone">
        <video
          src="/static/video/home_v2/1-1-phone.mp4"
          webkit-playsinline="true"
          playsInline="true"
          x5-video-player-type="h5"
          x5-video-player-fullscreen="true"
          x-webkit-airplay="true"
          muted
          loop
          autoPlay
        ></video>
        <div class="a-words-box-phone clr-fff">
          <p class="ft-title-a a-mgb-35">
            SMARTZ AI for Your Smart Home Management
          </p>
          <p class="ft-text-a a-mgb-75">
            SMARTZ AI is an Agentic AI which transforms home and rental property
            management by autonomously controlling smart home systems and
            optimizing operational tasks. These intelligent agents proactively
            handle environment control, tenant communications, maintenance
            scheduling, and market analysis, enabling property owners to
            maximize efficiency with minimal personal intervention.
          </p>
        </div>
      </div>
    </section>
    <section class="part2 bg-w">
      <div class="a-logo-list" style="display: none">
        <img src="/static/images/home_v2/logo-1.png" alt=""/>
        <img src="/static/images/home_v2/logo-2.png" alt=""/>
        <img src="/static/images/home_v2/logo-3.png" alt=""/>
        <img src="/static/images/home_v2/logo-4.png" alt=""/>
        <img src="/static/images/home_v2/logo-5.png" alt=""/>
        <img src="/static/images/home_v2/logo-6.png" alt=""/>
        <img src="/static/images/home_v2/logo-funlux.png" alt=""/>
        <img src="/static/images/home_v2/logo-gs.png" alt=""/>
        <img src="/static/images/home_v2/logo-isa.png" alt=""/>
        <img src="/static/images/home_v2/logo-sho.png" alt=""/>
      </div>

      <div id="swp2" style="margin: 0 auto; max-width: 1920px">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img src="/static/images/home_v2/logo-1.png" data-id="1" alt=""/>
            </div>
            <div class="swiper-slide">
              <img src="/static/images/home_v2/logo-2.png" data-id="2" alt=""/>
            </div>
            <div class="swiper-slide">
              <img src="/static/images/home_v2/logo-3.png" data-id="3" alt=""/>
            </div>
            <div class="swiper-slide">
              <img src="/static/images/home_v2/logo-4.png" data-id="4" alt=""/>
            </div>
            <div class="swiper-slide">
              <img src="/static/images/home_v2/logo-5.png" data-id="5" alt=""/>
            </div>
            <div class="swiper-slide">
              <img src="/static/images/home_v2/logo-6.png" data-id="6" alt=""/>
            </div>
            <div class="swiper-slide">
              <img
                src="/static/images/home_v2/logo-funlux.png"
                data-id="7"
                alt=""
              />
            </div>
            <div class="swiper-slide">
              <img
                src="/static/images/home_v2/logo-gs.png"
                data-id="8"
                alt=""
              />
            </div>
            <div class="swiper-slide">
              <img
                src="/static/images/home_v2/logo-isa.png"
                data-id="9"
                alt=""
              />
            </div>
            <div class="swiper-slide">
              <img
                src="/static/images/home_v2/logo-sho.png"
                data-id="10"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="no-used"></div>
      </div>

      <!--    <div class="a-main">-->
      <p class="ft-title-b">
        Trusted by millions of homes and numerous business partners worldwide.
      </p>

      <div class="a-video-box a-video-box-tom1">
        <video
          src="/static/video/home_v2/2-1.webm"
          webkit-playsinline="true"
          playsInline="true"
          x5-video-player-type="h5"
          x5-video-player-fullscreen="true"
          x-webkit-airplay="true"
          muted
          loop
          autoPlay
        ></video>
      </div>
      <div class="a-video-box a-video-box-tom">
        <video
          src="/static/video/home_v2/2-1-phone.mp4"
          webkit-playsinline="true"
          playsInline="true"
          x5-video-player-type="h5"
          x5-video-player-fullscreen="true"
          x-webkit-airplay="true"
          muted
          loop
          autoPlay
        ></video>
      </div>
    </section>
    <section class="part3 bg-d">
      <div class="a-main">
        <div class="a-flex a-flex-col-center a-flex-col-center-column-reverse">
          <div class="a-media-box">
            <!--            <video-->
            <!--              src="/static/video/home_v2/3-1.webm?v=1.0.0"-->
            <!--              class="a-width-100"-->
            <!--              webkit-playsinline="true"-->
            <!--              playsinline="true"-->
            <!--              x5-video-player-type="h5"-->
            <!--              x5-video-player-fullscreen="true"-->
            <!--              x-webkit-airplay="true"-->
            <!--              muted-->
            <!--              loop-->
            <!--              autoplay-->
            <!--            ></video>-->
            <img
              class="a-width-100"
              src="/static/video/home_v2/a2.gif"
              style="border-radius: 15px"
              alt=""
            />
            <img
              class="a-width-100-phone"
              src="/static/video/home_v2/3-1-phone.gif"
              alt=""
            />
          </div>
          <div class="a-words-box a-words-box-l">
            <p class="ft-title-c a-mgb-35">
              AI Guardian: Revolutionizing Home Security with Smart Surveillance
            </p>
            <p class="ft-text-a a-mgb-55">
              AI security systems and cloud video recording transform home
              protection by using intelligent algorithms to detect threats,
              recognize faces, and provide real-time monitoring. These
              technologies offer remote surveillance, instant alerts, and secure
              off-site video storage, giving families advanced protection and
              peace of mind.
            </p>
            <button class="b-btn">
              Learn More
              <img src="/static/images/home_v2/icon-2.png" alt=""/>
            </button>
          </div>
        </div>
      </div>
    </section>

    <section class="part4 bg-w">
      <div class="a-main">
        <div class="a-flex a-flex-col-center">
          <div class="a-words-box a-words-box-r">
            <p class="ft-title-c a-mgb-35">
              Smart Living: SMARTZ AI Agents Are Revolutionizing Home Management
            </p>
            <p class="ft-text-a a-mgb-55">
              AI home agent is a sophisticated system that intelligently manages
              household devices and events, learning from user behaviors to
              automate tasks, control smart home technologies, optimize energy
              usage, and provide personalized living experiences through
              seamless device integration and predictive capabilities.
            </p>
            <button class="b-btn">
              Learn More
              <img src="/static/images/home_v2/icon-2.png" alt=""/>
            </button>
          </div>
          <div class="a-media-box" style="text-align: right">
            <!--            <video-->
            <!--              src="/static/video/home_v2/3-2.webm?v=1.0.0"-->
            <!--              class="a-width-100"-->
            <!--              webkit-playsinline="true"-->
            <!--              playsinline="true"-->
            <!--              x5-video-player-type="h5"-->
            <!--              x5-video-player-fullscreen="true"-->
            <!--              x-webkit-airplay="true"-->
            <!--              muted-->
            <!--              loop-->
            <!--              autoplay-->
            <!--              style="width: 93%"-->
            <!--            ></video>-->
            <img
              class="a-width-100"
              style="border-radius: 15px"
              src="/static/video/home_v2/a1.gif"
              alt=""
            />
            <img
              class="a-width-100-phone"
              src="/static/video/home_v2/3-2-phone.gif"
              alt=""
            />
          </div>
        </div>
      </div>
    </section>

    <section class="part5" v-if="0">
      <div class="a-main">
        <div class="a-flex a-flex-col-center a-flex-col-center-column-reverse">
          <div class="a-media-box">
            <img
              class="a-width-100"
              src="/static/images/home_v2/2-3.png"
              alt=""
            />
          </div>
          <div class="a-words-box a-words-box-l">
            <p class="ft-title-c a-mgb-35">
              Capture and Share Important Moments
            </p>
            <p class="ft-text-a a-mgb-55">
              Smartz can help you find and capture the important moments in each
              day. Whether you’re looking to find a particular incident, or
              you’re hoping to capture and share a life milestone with loved
              ones, Smartz looks through all 1,440 minutes of the day to help
              you find that moment. It also uses AI to help you easily edit and
              share those videos.
            </p>
            <button class="b-btn">
              Learn More
              <img src="/static/images/home_v2/icon-2.png" alt=""/>
            </button>
          </div>
        </div>
      </div>
    </section>

    <section class="part6 bg-d">
      <div class="a-main">
        <div class="a-flex a-flex-col-center">
          <div class="a-media-box">
            <img
              class="a-width-100"
              src="/static/images/home_v2/2-4.png"
              alt=""
            />
          </div>
          <div class="a-words-box a-words-box-l">
            <p class="ft-title-c a-mgb-35">
              Better, More Efficient Management for Your Properties
            </p>
            <p class="ft-text-a a-mgb-55">
              Smartz optimizes energy use for heating, cooling, and lighting
              while predicting maintenance needs through IoT sensor data to
              prevent costly repairs. It can also assist in smarter budget
              management by tracking expenses and forecasting future costs. AI
              empowers homeowners to make informed decisions, leading to
              significant savings and a more sustainable living environment.
            </p>
            <button class="b-btn">
              Learn More
              <img src="/static/images/home_v2/icon-2.png" alt=""/>
            </button>
          </div>
        </div>
      </div>
    </section>

    <section class="part7 bg-w">
      <div class="a-main">
        <div class="a-flex a-flex-col-center a-flex-col-center-column-reverse">
          <div class="a-words-box a-words-box-r">
            <p class="ft-title-c a-mgb-35">
              The AI Assistant That Helps You Grow Your Future
            </p>
            <p class="ft-text-a a-mgb-55">
              Smartz helps you manage and grow your investment portfolio while
              minimizing your work and stress. Use Smartz to manage your
              long-term rentals and Airbnb properties. Smartz optimizes your
              energy use, provides security, and automates essential workflows
              like listings, tenant screening, rent collection, maintenance, and
              more. Smartz helps you improve satisfaction at minimum cost,
              unlocking your dreams for financial freedom.
            </p>
            <button class="b-btn">
              Learn More
              <img src="/static/images/home_v2/icon-2.png" alt=""/>
            </button>
          </div>
          <div class="a-media-box">
            <img
              class="a-width-100"
              src="/static/images/home_v2/2-5.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </section>

    <section class="part8 bg-d">
      <div class="a-main" style="position: relative">
        <p
          class="ft-title-c a-mgb-25"
          style="margin-left: auto; margin-right: auto; text-align: center"
        >
          Personalized AI Agent
        </p>
        <p
          class="ft-text-a"
          style="
            margin-left: auto;
            margin-right: auto;
            max-width: 600px;
            text-align: center;
            margin-bottom: 65px;
          "
        >
          Personalized AI agents are revolutionizing home automation by adapting
          to individual preferences and routines.
        </p>
        <div class="e-icg-box" v-if="0">
          <img
            class="a-width-100 a-width-101"
            src="/static/images/home_v2/8-1a.png?v=1.0.0"
            alt=""
          />
          <img
            class="a-width-100-phone"
            src="/static/images/home_v2/8-1a.png?v=1.0.0"
            alt=""
          />
          <!--          <div class="a-ai-box">-->
          <!--            <video-->
          <!--              class="ai-v-btn"-->
          <!--              src="/static/video/home_v2/Logo_loading.webm?v=1.0.0"-->
          <!--              webkit-playsinline="true"-->
          <!--              playsinline="true"-->
          <!--              x5-video-player-type="h5"-->
          <!--              x5-video-player-fullscreen="true"-->
          <!--              x-webkit-airplay="true"-->
          <!--              muted-->
          <!--              loop-->
          <!--              autoplay-->
          <!--            ></video>-->
          <!--            <img-->
          <!--              data-v-de1f5744=""-->
          <!--              src="/static/video/ai_v2/robot1.gif"-->
          <!--              alt=""-->
          <!--              class="ai-v-btn-phone"-->
          <!--            />-->
          <!--          </div>-->
        </div>

        <div class="e-icg-box-ii">
          <div>
            <div
              class="a-video-box"
              style="width: 100%; margin-left: 0; margin-right: 0"
            >
              <video
                src="/static/video/home_v2/p1.webm"
                webkit-playsinline="true"
                playsInline="true"
                x5-video-player-type="h5"
                x5-video-player-fullscreen="true"
                x-webkit-airplay="true"
                muted
                loop
                autoPlay
              ></video>
            </div>
            <!-- <img src="/static/images/home_v2/icon-c.png" alt="" /> -->

            <!-- <div class="a-img-words-con a-ly-revs ps-a1">
              <div class="a-img-con">
                <img src="/static/images/home_v2/icon-a-1.png" alt="" />
              </div>
              <div class="a-words-con">
                <div class="a-words-i-con">
                  <h3>Home Automation</h3>
                  <p>
                    Smart homes evolve into intelligent ecosystems, with
                    autonomous agents learning, adapting, and managing tasks
                    seamlessly, creating responsive living spaces that
                    anticipate needs and optimize efficiency.
                  </p>
                </div>
              </div>
            </div>
            <div class="a-img-words-con a-ly-revs ps-a2">
              <div class="a-img-con">
                <img src="/static/images/home_v2/icon-a-2.png" alt="" />
              </div>
              <div class="a-words-con">
                <div class="a-words-i-con">
                  <h3>Home Security</h3>
                  <p>
                    Your intelligent home guardian that learns, predicts, and
                    protects in real-time, transforming security from reactive
                    to proactive.
                  </p>
                </div>
              </div>
            </div> -->

            <!-- <div class="a-img-words-con a-ly-revs ps-a3">
              <div class="a-img-con">
                <img src="/static/images/home_v2/icon-a-3.png" alt="" />
              </div>
              <div class="a-words-con">
                <div class="a-words-i-con">
                  <h3>Home property Management</h3>
                  <p>
                    The AI PM Agent learns, anticipates needs, and streamlines
                    operations, boosting efficiency and tenant satisfaction for
                    both long-term rentals and short-term Airbnb properties.
                  </p>
                </div>
              </div>
            </div>
            <div class="a-img-words-con a-ly-revs ps-a4">
              <div class="a-img-con">
                <img src="/static/images/home_v2/icon-a-4.png" alt="" />
              </div>
              <div class="a-words-con">
                <div class="a-words-i-con">
                  <h3>Enhanced Experience</h3>
                  <p>
                    Empowers families to create personalized entertainment,
                    transforming everyday moments into magical memories through
                    intelligent video editing, story generation, and content
                    enhancement—making digital storytelling simple and engaging.
                  </p>
                </div>
              </div>
            </div> -->

            <!-- <div class="a-img-words-con ps-b1">
              <div class="a-img-con">
                <img src="/static/images/home_v2/icon-b-1.png" alt="" />
              </div>
              <div class="a-words-con">
                <div class="a-words-i-con">
                  <h3>Personalized AI</h3>
                  <p>
                    Your personal AI companion: an intelligent digital assistant
                    that learns, adapts, and evolves uniquely with you,
                    transforming interactions through deep personalization and
                    predictive understanding.
                  </p>
                </div>
              </div>
            </div>
            <div class="a-img-words-con ps-b2">
              <div class="a-img-con">
                <img src="/static/images/home_v2/icon-b-2.png" alt="" />
              </div>
              <div class="a-words-con">
                <div class="a-words-i-con">
                  <h3>Safety & Privacy</h3>
                  <p>
                    Your personalized AI agents protect user privacy through
                    robust encryption, ethical guidelines, and transparent data
                    controls, ensuring a secure digital experience with
                    user-centric safety at its core.
                  </p>
                </div>
              </div>
            </div>

            <div class="a-img-words-con ps-b3">
              <div class="a-img-con">
                <img src="/static/images/home_v2/icon-b-3.png" alt="" />
              </div>
              <div class="a-words-con">
                <div class="a-words-i-con">
                  <h3>Self Learning & Improving</h3>
                  <p>
                    Self-learning AI agents autonomously evolve by analyzing
                    interactions, adapting algorithms, and optimizing
                    performance to deliver increasingly personalized and
                    intelligent experiences with minimal human intervention.
                  </p>
                </div>
              </div>
            </div> -->
            <!-- <div class="a-img-words-con ps-b4">
              <div class="a-img-con">
                <img src="/static/images/home_v2/icon-b-4.png" alt="" />
              </div>
              <div class="a-words-con">
                <div class="a-words-i-con">
                  <h3>Getting Smarter</h3>
                  <p>
                    Proactively take actions without explicit user input, set
                    their own goals, make autonomous decisions, and adapt to
                    changing conditions and user habits over time.
                  </p>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </section>

    <section class="part9" v-if="0">
      <div class="a-video-box">
        <video
          src="/static/video/home_v2/9-1.webm"
          webkit-playsinline="true"
          playsInline="true"
          x5-video-player-type="h5"
          x5-video-player-fullscreen="true"
          x-webkit-airplay="true"
          muted
          loop
          autoPlay
        ></video>
      </div>

      <div class="x-card-box --in-phone">
        <div class="x-card-box-txt">Products & Services</div>
        <div class="img-con">
          <img
            data-v-498142aa=""
            src="/static/images/home/240729/Phone-02.png"
            alt=""
            class="phone-img"
          />
        </div>
        <div class="swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="swiper-slide-tom">
                <div>
                  <img
                    class="swiper-slide-img"
                    data-v-498142aa=""
                    src="/static/images/home/240729/screen-1.gif"
                    alt=""
                    style=""
                  />
                </div>
                <div class="con-tom">
                  <div class="title">
                    <p>
                      <img
                        data-v-498142aa=""
                        src="/static/images/home/240726/icon-1.png"
                        alt=""
                      />
                    </p>
                    <p>Live Video Access</p>
                  </div>
                  <div class="txt">
                    Discover the latest promotions and intriguing moments
                    captured by your camera in the Explore module.
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="swiper-slide-tom">
                <div>
                  <img
                    class="swiper-slide-img"
                    data-v-498142aa=""
                    src="/static/images/home/240805/screen-2.png"
                    alt=""
                    style=""
                  />
                </div>
                <div class="con-tom">
                  <div class="title">
                    <p>
                      <img
                        data-v-498142aa=""
                        src="/static/images/home/240726/icon-2.png"
                        alt=""
                      />
                    </p>
                    <p>Discover Insights</p>
                  </div>
                  <div class="txt">
                    Discover the latest promotions and intriguing moments
                    captured by your camera in the Explore module.
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="swiper-slide-tom">
                <div>
                  <img
                    class="swiper-slide-img"
                    data-v-498142aa=""
                    src="/static/images/home/240729/screen-3.png"
                    alt=""
                    style=""
                  />
                </div>
                <div class="con-tom">
                  <div class="title">
                    <p>
                      <img
                        data-v-498142aa=""
                        src="/static/images/home/240726/icon-3.png"
                        alt=""
                      />
                    </p>
                    <p>Property Control Center</p>
                  </div>
                  <div class="txt">
                    Manage all your properties in one app. Monitor rental
                    status, track energy consumption, and handle billing—all
                    from a single platform.
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="swiper-slide-tom">
                <div>
                  <img
                    class="swiper-slide-img"
                    data-v-498142aa=""
                    src="/static/images/price/240730/4.gif"
                    alt=""
                    style=""
                  />
                </div>
                <div class="con-tom">
                  <div class="title">
                    <p>
                      <img
                        data-v-498142aa=""
                        src="/static/images/home/240726/icon-6.png"
                        alt=""
                      />
                    </p>
                    <p>Smart Alerts</p>
                  </div>
                  <div class="txt">
                    Enhance your alert accuracy with AI-powered detection for
                    people, animals, vehicles, and packages.
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="swiper-slide-tom">
                <div>
                  <img
                    class="swiper-slide-img"
                    data-v-498142aa=""
                    src="/static/images/home/240820/screen-5.png"
                    alt=""
                    style=""
                  />
                </div>
                <div class="con-tom">
                  <div class="title">
                    <p>
                      <img
                        data-v-498142aa=""
                        src="/static/images/home/240729/icon-5.png"
                        alt=""
                      />
                    </p>
                    <p>AI Assistant</p>
                  </div>
                  <div class="txt">
                    Use the AI Assistant to quickly and easily handle routine
                    questions—no more long wait times.
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="swiper-slide-tom">
                <div>
                  <img
                    class="swiper-slide-img"
                    data-v-498142aa=""
                    src="/static/images/home/240729/screen-6.png"
                    alt=""
                    style=""
                  />
                </div>
                <div class="con-tom">
                  <div class="title">
                    <p>
                      <img
                        data-v-498142aa=""
                        src="/static/images/home/240726/icon-4.png"
                        alt=""
                      />
                    </p>
                    <p>Device Control</p>
                  </div>
                  <div class="txt">
                    Manage all your devices in one place. Check device status,
                    set preferences, and edit data—all from here.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Swiper from "swiper";
import * as dayjs from "dayjs";
import {pageLoadEvent} from "../../api/submitEvent";

export default {
  name: "index",
  mounted() {
    new Swiper("#swp2 .swiper-container", {
      autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      }, //可选选项，自动滑动
      // onlyExternal: true,
      speed: 4000,
      loop: true,
      spaceBetween: 0,
      slidesPerView: "auto",
      watchSlidesProgress: true,
      loopPreventsSlide: true,
      mousewheel: false,
      touch: false,
    });

    this.loadPageFun();
    this.initSwiper();
  },
  methods: {
    loadPageFun() {
      let _obj = {
        url: ``,
        code: "BATCH_WEB_" + dayjs().format("YYYYMMDD"),
        page: "homepage",
        other: "",
      };
      try {
        pageLoadEvent(_obj);
      } catch (e) {
        console.log(e);
      }
    },
    initSwiper() {
      var mySwiper1 = new Swiper(".x-card-box .swiper", {
        autoplay: false,
        loop: true,
        slidesPerView: 3,
        spaceBetween: "-5%",
        slidesPerView: "auto",
        centeredSlides: true,
        pagination: {
          el: ".x-card-box .swiper-pagination",
          clickable: true,
          type: "bullets",
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/common.scss";
@import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/home_v2/index.vue